import { CardDetails } from 'core/tarjeta/components/CardDetails/CardDetails';
import { CardMovementsList } from 'core/tarjeta/components/CardMovementsList/CardMovementsList';
import { CardTotalsReportContext } from 'core/tarjeta/contexts/CardTotalsReportContext';
import { useContext } from 'react';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { LinkButton } from 'shared/components';

export const CardTotalsReportPage = () => {
  const {
    cardData,
    goBack,
    goToCardAuthorizations,
    goToAccountMovements,
    searchParams,
    groupByCategory,
    movimientos,
    movimientosRubro,
    rubros,
  } = useContext(CardTotalsReportContext);

  return (
    <Container>
      {movimientos ? (
        <>
          <Row className="mb-3">
            <Col>
              <CardDetails
                cardData={cardData}
                goBack={goBack}
                goToAccountMovements={goToAccountMovements}
                searchParams={searchParams}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <CardMovementsList
                groupByCategory={groupByCategory}
                movimientos={movimientos}
                movimientosRubro={movimientosRubro}
                rubros={rubros}
                searchParams={searchParams}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col className="text-center">
              <LinkButton onClick={goToCardAuthorizations}>
                Autorizaciones para la tarjeta
              </LinkButton>
            </Col>
            <Col className="text-center">
              <LinkButton onClick={goBack}>Volver</LinkButton>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col>
              <Alert className="text-center">
                No hay movimientos en el período para esta tarjeta.
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <LinkButton onClick={goBack}>Volver</LinkButton>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};
